import React, { useContext } from 'react';
import { Dialog } from 'primereact/dialog';
import { LocaleContext } from './LocaleContext';

export default function PrintOptionsDialog({
  visible,
  onHide,
  orientation,
  onOrientationChange,
  layout,
  onLayoutChange,
  onConfirm,
  confirmLabel,
}) {
  const { t } = useContext(LocaleContext);
  const buttonLabel = confirmLabel || t('Common.Print');

  return (
    <Dialog
      header={t('Common.PrintList')}
      visible={visible}
      style={{ width: 'min(460px, 92vw)' }}
      onHide={onHide}
    >
      <div className="flex flex-col gap-3">
        <div className="text-sm text-gray-700">{t('Common.ChooseOrientation')}:</div>
        <div className="flex gap-2">
          <button
            type="button"
            className={`flex-1 min-h-[38px] px-3 py-2 rounded-md text-sm border ${orientation === 'portrait' ? 'bg-zinc-900 text-white border-zinc-900' : 'bg-white text-zinc-900 border-zinc-300 hover:bg-zinc-100'}`}
            onClick={() => onOrientationChange?.('portrait')}
          >
            {t('Common.Portrait')}
          </button>
          <button
            type="button"
            className={`flex-1 min-h-[38px] px-3 py-2 rounded-md text-sm border ${orientation === 'landscape' ? 'bg-zinc-900 text-white border-zinc-900' : 'bg-white text-zinc-900 border-zinc-300 hover:bg-zinc-100'}`}
            onClick={() => onOrientationChange?.('landscape')}
          >
            {t('Common.Landscape')}
          </button>
        </div>

        <div className="text-sm text-gray-700 mt-1">{t('Common.PrintStyle')}:</div>
        <div className="flex gap-2">
          <button
            type="button"
            className={`flex-1 min-h-[38px] px-3 py-2 rounded-md text-sm border ${layout === 'branded' ? 'bg-zinc-900 text-white border-zinc-900' : 'bg-white text-zinc-900 border-zinc-300 hover:bg-zinc-100'}`}
            onClick={() => onLayoutChange?.('branded')}
          >
            {t('Common.WithHeaderFooter')}
          </button>
          <button
            type="button"
            className={`flex-1 min-h-[38px] px-3 py-2 rounded-md text-sm border ${layout === 'minimal' ? 'bg-zinc-900 text-white border-zinc-900' : 'bg-white text-zinc-900 border-zinc-300 hover:bg-zinc-100'}`}
            onClick={() => onLayoutChange?.('minimal')}
          >
            {t('Common.WithoutHeaderFooter')}
          </button>
        </div>

        <button
          type="button"
          onClick={onConfirm}
          className="mt-2 px-4 py-2 text-center tracking-wide text-white transition-colors duration-200 transform bg-zinc-900 rounded-md hover:bg-zinc-700"
        >
          {buttonLabel}
        </button>
      </div>
    </Dialog>
  );
}
